export const mainBaseUrl = process.env.BACKEND_APIS_BASE_URL;